import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import style from './style.module.css';

/**
 * Stateless component for general result row.
 *
 * @param props {Object}.
 * @param props.className {String} Row class.
 * @param props.linkTo {String} Link to.
 * @param props.children {any} Child elements.
 */
const GeneralResultRowComponent = ({ children, linkTo, className }) => (
  <Link className={classNames(style.host, className)} target="_blank" to={linkTo}>
    {children}
  </Link>
);

GeneralResultRowComponent.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  linkTo: PropTypes.string.isRequired,
};

export const GeneralResultRow = memo(GeneralResultRowComponent);
